import React, { useEffect, useState } from "react";
import { Modal, Typography, Box, Backdrop, Button, IconButton, Paper } from '@mui/material';
import { API, graphqlOperation } from "aws-amplify";
import { deleteInvoiceMaster } from '../../graphql/mutations';
import { LoadingButton } from "@mui/lab";
import { getTransactionRelation } from "../../graphql/queries";
import TeaxtareaField from "../formElements/TeaxtareaField";
import CloseIcon from '@mui/icons-material/Close';
import { showSuccessSnackbar, showWarningSnackbar } from "../snackBar/snakbar";
import { useNavigate } from "react-router-dom";
import { useThemes } from "../Theme/theme";

const generateStyle = (width = null) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    boxShadow: 24,
    outline: "none",
    borderRadius: "4px",
    width: width || 'auto',
});

const style = generateStyle();
const reasonModalStyle = generateStyle('30%');


const DeleteInvoice = ({ open, setOpen, itemData, rows, setRows, listInvoices, listPos }) => {
    const { theme } = useThemes()

    const [loading, setLoading] = useState(false);
    const [linkedPayments, setLinkedPayments] = useState([]);
    const [showReasonModal, setShowReasonModal] = useState(false);
    const [state, setState] = useState({
        reason: "",
        errorStatus: {
            reason: false,
        },
        errorFields: {
            reason: "",
        }
    })
    const handleClose = (event, reason) => {
        if (reason !== 'backdropClick') {
            setOpen(false);
            setState({
                reason: "",
                errorStatus: {
                    reason: false,
                },
                errorFields: {
                    reason: "",
                }
            })
        }
    }
    async function getLinkedTransaction() {
        try {
            const res = await API.graphql(
                graphqlOperation(getTransactionRelation, { ObjectID: itemData?.id })
            )
            let linkedPaymentDetails = res.data.getTransactionRelation.filter((ele) => {
                if (ele.IsDirect == 1) {
                    return ele
                }

            })
            console.log(res.data)
            setLinkedPayments(linkedPaymentDetails)

        } catch (error) {
            console.log("error");
        }
    }
    useEffect(() => {
        if (open && itemData?.id)
            getLinkedTransaction()

    }, [open])
    let navigate = useNavigate()

    async function deleteInvoiceMasterDet(data) {
        try {
            setLoading(true)
            const res = await API.graphql(
                graphqlOperation(deleteInvoiceMaster, data)
            )
            console.log(res.data?.deleteInvoiceMaster)
            if (res.data?.deleteInvoiceMaster != null) {
                let arr = rows?.filter((item, ind) => {
                    if (ind != itemData?.ind) {
                        return item
                    }
                })
                setLoading(false)
                setOpen(false)
                if (setState) {
                    setState({
                        reason: "",
                        errorStatus: {
                            reason: false,
                        },
                        errorFields: {
                            reason: "",
                        }
                    })
                }
                setShowReasonModal(false)
                if (itemData.invoicetype == "POS") {
                    showSuccessSnackbar("POS Deleted!")
                    if (listPos) {
                        listPos()
                    }
                }
                else {
                    if (listInvoices) {
                        listInvoices()
                    }

                    showSuccessSnackbar("Invoice Deleted!")
                }
                if (itemData?.nav) {
                    navigate(itemData?.nav)
                }
                // setDeleteSuccessSnakbar(true)

            } else {
                alert('Item not Deleted.! something went wrong. please try again')
                setOpen(false)
                setLoading(false)
                setShowReasonModal(false)
            }
            // console.log(res);
        } catch (error) {
            setLoading(false)
            console.log(error);
        }

    }



    const deleteItem = () => {
        setLoading(true)
        if (linkedPayments.length > 0) {
            showWarningSnackbar("Linked Payments exists. Please unlink the linked payments before deletion!")
            setLoading(false)
            setOpen(false)
        } else {
            setShowReasonModal(true)
            setLoading(false)
        }
    }

    const DeleteSelectedInvoice = () => {
        let errorMessage = "";
        let isError = false;

        if (state?.reason === "") {
            errorMessage = "Reason for Deletion is Required";
            isError = true;
        } else if (state?.reason?.trim().length > 250) {
            errorMessage = "Reason for Deletion must be less than 250 characters";
            isError = true;
        }

        setState(prev => ({
            ...prev,
            errorStatus: {
                ...prev.errorStatus,
                reason: isError,
            },
            errorFields: {
                ...prev.errorFields,
                reason: errorMessage,
            },
        }));

        if (!isError) {
            deleteInvoiceMasterDet({ InvoiceID: itemData?.id, DeleteRemark: state?.reason });
        }
    };


    return (

        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            {/* <Fade in={open}> */}
            {/* <Box sx={style}> */}
            {!showReasonModal ? (

                <Paper sx={style}>
                    <Box sx={{
                        borderRadius: "4px",
                        padding: "15px",
                        textAlign: "center",
                        overflowY: { xs: 'scroll', sm: 'hidden' },
                        '.MuiTableCell-root': {
                            padding: '10px 10px',
                            fontSize: '13px'
                        },
                    }}>

                        <Typography sx={{ color: theme?.palette?.TmId.id.toString().includes("9") ? "" : "rgb(60 60 60)", fontWeight: "bold" }}>
                            Do you want to delete this Invoice?
                        </Typography>
                    </Box>


                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        // flexDirection: { xs: 'column', sm: 'row' },
                        paddingLeft: "15px",
                        paddingRight: "15px",
                        paddingBottom: "15px",
                    }}>
                        <Button disabled={false} onClick={handleClose} variant='outlined' sx={{ flex: 1, margin: '5px', fontSize: "12px" }} >No</Button>
                        {/* <Button color="error" onClick={() => deleteItem()} variant='contained' sx={{ flex: 1, margin: '5px', fontSize: "12px" }} >Yes</Button> */}
                        <LoadingButton color="error" sx={{ flex: 1, margin: '5px', fontSize: "12px" }} loading={loading} disableRipple={true} variant="contained" onClick={() => deleteItem()}>
                            Yes
                        </LoadingButton>

                    </Box>
                </Paper>
            )
                : (

                    <Box sx={reasonModalStyle}>
                        <Box sx={{
                            backgroundColor: "primary.main",
                            padding: "10px 15px",
                            display: "flex",
                            flexDirection: "row",
                        }}>
                            <Box sx={{ flex: 1 }}>
                                <Typography sx={{ color: "#fff", display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    {
                                        'Enter Reason for Deletion'
                                    }
                                    <IconButton aria-label="delete"
                                        onClick={() => {
                                            setState({
                                                reason: "",
                                                errorStatus: {
                                                    reason: false,
                                                },
                                                errorFields: {
                                                    reason: "",
                                                }
                                            })
                                            setShowReasonModal(false)
                                            setLoading(false)
                                        }}
                                    >
                                        <CloseIcon sx={{ color: '#fff' }} />
                                    </IconButton>
                                </Typography>

                            </Box>
                        </Box>
                        <Box sx={{ padding: '15px' }}>
                            <TeaxtareaField
                                name="reason"
                                placeholder="Reason for Deletion"
                                size="small"
                                fullWidth
                                rows={6}
                                state={state}
                                value={state.reason}
                                onChange={(e) => {
                                    if (e.target.value.length > 250) {
                                        setState((prev) => ({
                                            ...prev,
                                            ["reason"]: e.target.value,
                                            ["errorStatus"]: {
                                                ...prev.errorStatus,
                                                ["reason"]: true,
                                            },
                                            ["errorFields"]: {
                                                ...prev.errorFields,
                                                ["reason"]:
                                                    "Reason for Deletion must be less than 250 characters",
                                            },
                                        }));
                                    } else if (e.target.value.length <= 0) {
                                        setState((prev) => ({
                                            ...prev,
                                            ["reason"]: e.target.value,
                                            ["errorStatus"]: {
                                                ...prev.errorStatus,
                                                ["reason"]: true,
                                            },
                                            ["errorFields"]: {
                                                ...prev.errorFields,
                                                ["reason"]:
                                                    "Reason for Deletion is Required",
                                            },
                                        }));
                                    }
                                    else {
                                        setState((prev) => ({
                                            ...prev,
                                            ["reason"]: e.target.value,
                                            ["errorStatus"]: {
                                                ...prev.errorStatus,
                                                ["reason"]: false,
                                            },
                                            ["errorFields"]: {
                                                ...prev.errorFields,
                                                ["reason"]: "",
                                            },
                                        }));
                                    }
                                }}
                            />
                            <Box
                                sx={{
                                    marginTop: "10px",
                                    width: "100%",
                                    display: "flex",
                                    justifyContent: { xs: "space-around", sm: "end" },
                                    flexWrap: "wrap",
                                    flexDirection: { xs: "column", sm: "row" },
                                    zIndex: 1,
                                }}
                            >
                                <Box
                                    sx={{
                                        marginTop: "10px",
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: { xs: "space-around", sm: "end" },
                                        flexWrap: "wrap",
                                        flexDirection: { xs: "column", sm: "row" },
                                    }}
                                >
                                    <LoadingButton sx={{ flex: 1, margin: '5px', fontSize: "12px", background: "primary.main" }} loading={loading} disableRipple={true} variant="contained" onClick={() => DeleteSelectedInvoice()}>
                                        Submit
                                    </LoadingButton>

                                </Box>

                            </Box>
                        </Box>

                    </Box>
                )
            }




            {/* </Box> */}
            {/* </Fade> */}
        </Modal>

    );
};

export default DeleteInvoice;